<section class="section livre-blanc-form-confirmation">
  <div class="section-header">
    <mat-icon class="validation-icon">check_circle</mat-icon>
  </div>

  <div class="section-content">
    <!-- <h3 class="subtitle">{{ (tunnelsContent$ | async)?.tunnel_download_2_titre }}</h3> -->
    <h3 class="subtitle">Merci!</h3>

    <!-- <p class="lead">{{ (tunnelsContent$ | async)?.tunnel_download_2_sous_titre }}</p> -->
    <p class="lead">
      Nous venons de vous envoyer votre contenu dans votre boite mail.
    </p>
    <p class="lead">
      Si vous ne voyez toujours rien dans 5 min, allez faire un petit tour dans
      vos spams !
    </p>
    <p class="lead">À bientôt!</p>
  </div>
  <div class="section-footer">
    <!-- <a [routerLink]="['/home']" class="btn btn-rounded btn-action">{{
      (tunnelsContent$ | async)?.tunnel_download_2_button_texte
    }}</a> -->
    <a
      [routerLink]="['/' + rootPage + '/' + pageSlug]"
      class="btn btn-rounded btn-action"
      >Retour</a
    >
  </div>
</section>
